import axios from "axios";
class DefaultTemplate {
    /**
     * Get Default Template email used per stage
     * @constructor
     * @param {Number} stage -- the current stage
     * @param {String} token -- the auth token required
     * @param {String} key -- additional key
     * */
    constructor(stage, token, key = null) {
        this.stage = stage;
        this.token = token;
        this.key = key;
    }

    /**
     * To perform the query
     * @method
     * @returns {Promise}
     */
    async handle() {
        return new Promise(async (resolve, reject) => {
            try {
                let config = {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    }
                };

                if (this.key) {
                    config["params"] = {
                        key: this.key
                    };
                }
                let res = await axios.get(
                    `/api/v2/email_templates/${this.stage}/stage`,
                    config
                );
                resolve(res.data);
            } catch (err) {
                reject(err);
            }
        });
    }

    async getTemplateByName() {
        return new Promise(async (resolve, reject) => {
            try {
                let config = {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    }
                };

                let res = await axios.get(`/api/v2/_modules/email_templates`, {
                    ...config,
                    params: {
                        key: this.key
                    }
                });
                resolve(res.data);
            } catch (err) {
                reject(err);
            }
        });
    }
}

export default DefaultTemplate;
